import { createSelector } from 'reselect';

import {
    projectsSelector,
    groupsSelector,
    environmentTypesSelector as allEnvironmentTypes,
    timePeriodsSelector
} from './base';
import { settingsSelector } from './settings';
import { getLineDataset, getBarDataset, getViewInfo, shouldAggregate, specificOrFirst, getGroupedDataset } from './helpers';

export const environmentTypesSelector = createSelector([allEnvironmentTypes], list => {
    const l = list.filter(item => item.name != 'Dev');
    return [{ id: -1, name: 'All' }, ...l]
});

const getDisplay = createSelector([settingsSelector], settings => settings.deploymentFrequency.display);

const getSelectedSummaryIndex = state => state.newdashboard.deploymentFrequency.get('dataDisplayIndex');
const getEnvironmentType = state => state.newdashboard.deploymentFrequency.get('environmentType');
const getTimePeriod = state => state.newdashboard.deploymentFrequency.get('timePeriod');
export const summariesSelector = state => {
    const summaries = state.newdashboard.deploymentFrequency.get('summaries');
    return summaries ? summaries.toJS() : [];
};

const getGraphType = state => state.newdashboard.deploymentFrequency.get('graphType');

const getData = state => {
    const data = state.newdashboard.deploymentFrequency.get('data');
    return data ? data.toJS() : {};
}

const timePeriodSelector = createSelector([timePeriodsSelector, getTimePeriod], (list, item) => {
    const t = item || list[0];
    return t && t.toJS ? t.toJS() : t;
});

const environmentTypeSelector = createSelector([environmentTypesSelector, getEnvironmentType], (list, item) => {
    const t = item || list[0];
    return t && t.toJS ? t.toJS() : t;
});

export const dataSelector = createSelector([
    getData,
    summariesSelector,
    getSelectedSummaryIndex,
    projectsSelector,
    groupsSelector,
    getGraphType,
    environmentTypesSelector
], (data, summaries, summaryIndex, projects, groups, graphType, environmentTypes, environmentTypeSelector) => {
    const summary = summaries && summaries.length > 0 ? (summaries.length > summaryIndex ? summaries[summaryIndex] : summaries[0]) : { title: '', isPositive: true };
    switch (graphType) {
        case 'Line':
            return getLineDataset(data, summaryIndex, projects, groups, shouldAggregate(data, summaries));
        case 'Chart':
            return getBarDataset(data, summary, projects, groups);
        case 'ChartGroup':
            return getGroupedDataset(data, summary, projects, groups, environmentTypes.splice(1));
        default:
            return null;
    }
});

export const viewInfoSelector = createSelector([getDisplay], display => getViewInfo(display, 'deploymentFrequency'));

export const filtersSelector = createSelector([
    timePeriodSelector,
    environmentTypeSelector,
    getGraphType
], (timePeriod, environmentType, graphType) => ({ timePeriod, environmentType, graphType }));

export const summarySelector = createSelector([
    summariesSelector,
    getSelectedSummaryIndex
], specificOrFirst);

export const loadingSelector = state => state.newdashboard.deploymentFrequency.get('loading');
export const excludedItemsSelector = state => state.newdashboard.deploymentFrequency.get('excludedLegendItems');
export const timePeriodInfoSelector = state => state.newdashboard.deploymentFrequency.get('timePeriodInfo').toJS();



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/selectors/deployment-frequency.js